export { CanvasManager, setControls } from './canvas';
export { HotkeyManager } from './hotkeys';
export { ContextMenu } from './context-menu';
export { FullscreenMode } from './fullscreen';
export { initPlaceholderAutocomplete } from './placeholder-autocomplete';
